const tableTitleCompany = {
  title: 'Empresas',
  placeholder: 'Pesquisar',
  Typography: 'Nenhum resultado encontrado'
};

export default tableTitleCompany;
